import React from 'react';
import styles from './Lozenge.less';
import cx from 'classnames';

interface LozengeProps {
  color: 'green' | 'blue';
}

export const Lozenge: React.FunctionComponent<LozengeProps> = ({
  color,
  children,
}) => <span className={cx(styles.lozenge, styles[color])}>{children}</span>;
